import React from "react";
import Grid from "@mui/material/Grid";
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import {Control, UseFormRegister} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {Controller } from "react-hook-form";
import {IPharmacyType} from "../../../../queries/pharmacy/pharmacyModel";
import {FormControl} from "@mui/material";

interface OtherDetailsProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  control: Control<any>;
  pharmacyTypes: IPharmacyType[];
}

const OtherDetails:React.FunctionComponent<OtherDetailsProps> = ({
  register,
  errors,
  control,
  pharmacyTypes,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6} md={6}>
      <TextField
        label="Pharmacy Manager(Pic)/Contact Name"
        id="managerContactName"
        fullWidth
        required
        helperText={errors.managerContactName?.message?.toString()}
        {...register('managerContactName')}
        error={!!errors.managerContactName}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <TextField
        label="Contract Manager"
        id="contractManager"
        fullWidth
        required
        helperText={errors.contractManager?.message?.toString()}
        {...register('contractManager')}
        error={!!errors.contractManager}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <Controller
        name="pharmacyType"
        control={control}
        defaultValue=''
        render={({ field }) => (
          <FormControl fullWidth>
            <InputLabel id="pharmacyType-label">Pharmacy Type</InputLabel>
            <Select
              {...field}
              labelId="pharmacyType-label"
              id="pharmacyType"
              label="Pharmacy Type"
              fullWidth
              required
              {...register('pharmacyType')}
              error={!!errors.pharmacyType}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {pharmacyTypes.map((pharmacyType: IPharmacyType) => (
                <MenuItem key={pharmacyType.id} value={pharmacyType.id}>{pharmacyType.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <FormLabel id="is340B-radios">340B Status</FormLabel>
      <Controller
        name="is340B"
        control={control}
        defaultValue='YES'
        render={({ field }) => (
          <RadioGroup {...field} aria-labelledby="is340B-radios" row id="is340B" >
            <FormControlLabel value="YES" control={<Radio />} label="Yes" />
            <FormControlLabel value="NO" control={<Radio />} label="No" />
          </RadioGroup>
        )}
      />
    </Grid>
  </Grid>
)

export default OtherDetails;